import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import AppStoreBadges from '../AppStoreBadges';

const Shell = styled.footer`
  background: var(--color-midnight);
  color: var(--color-cream);
  padding: 3.5rem 1.5rem 1.5rem;
  border-top: 1px solid #47396d;
`;
const Inner = styled.div`max-width: 1160px; margin-inline: auto;`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 3rem;
  padding-bottom: 3rem;
  > div > h2 { font-size: 0.75rem; color: var(--color-teal); text-transform: uppercase; letter-spacing: 0.12em; margin-bottom: 1.25rem; }
  nav { display: flex; flex-direction: column; gap: 0.35rem; font-size: 0.875rem; }
  nav a { display: inline-flex; align-items: center; min-height: 36px; }
  nav a { color: #d9d3e9; }
  nav a:hover { color: var(--color-teal); }
  @media (max-width: 700px) { grid-template-columns: 1fr 1fr; gap: 2.5rem 1rem; > div:first-child { grid-column: 1 / -1; } }
`;
const Brand = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-size: 1.75rem;
  letter-spacing: -0.06em;
  font-weight: 800;
  color: var(--color-cream);
  &:hover { color: var(--color-teal); }
  img { width: 62px; height: 62px; }
`;
const Tagline = styled.p`color: #c5bddb; max-width: 34ch; font-size: 0.9rem; margin-block: 0.5rem 1.5rem;`;
const Stores = styled.div`width: fit-content; max-width: 100%;`;
const Bottom = styled.div`
  border-top: 1px solid #47396d;
  padding-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem 2rem;
  color: #c5bddb;
  font-size: 0.75rem;
`;
const Footer: React.FC = () => <Shell>
  <Inner>
    <Grid>
      <div>
        <Brand to="/" aria-label="Pasur home"><img src="/images/pasur-mark.png" width="62" height="62" alt="" />Pasur</Brand>
        <Tagline>The Iranian card game, ready for your next round. Play online, practice, or keep score together.</Tagline>
        <Stores><AppStoreBadges variant="light" size="sm" /></Stores>
      </div>
      <div>
        <h2>At the table</h2>
        <nav aria-label="Explore Pasur"><Link to="/">Home</Link><Link to="/rules">How to play</Link><Link to="/blog/">The notebook</Link><a href="mailto:team@pasurscorekeeper.com">Contact us</a></nav>
      </div>
      <div>
        <h2>The details</h2>
        <nav aria-label="Legal and account information"><Link to="/terms">Terms of Service</Link><Link to="/privacy">Privacy Policy</Link><a href="/delete-account.html">Delete an account</a></nav>
      </div>
    </Grid>
    <Bottom><p>© {new Date().getFullYear()} Pasur Score Keeper. All rights reserved.</p><p>Made in NYC. Played together.</p></Bottom>
  </Inner>
</Shell>;
export default Footer;
